import { AgentIcon } from "@promptlayer/ui";
import type { ReactNode } from "react";

import { Avatar, AvatarFallback } from "@/components/ui/avatar";
import { BasicTooltip } from "@/components/ui/Tooltip";
import { cn } from "@/lib/utils";

export const MessageAvatar = ({
  className,
  customAgentIcon,
  label = "Assistant",
}: {
  className?: string;
  customAgentIcon?: ReactNode;
  label?: string;
}) => (
  <BasicTooltip content={label}>
    <Avatar className={cn("h-6 w-6 shrink-0", className)}>
      <AvatarFallback className={cn("text-xs", "bg-gray-200 text-gray-600")}>
        {customAgentIcon ?? <AgentIcon className="h-4 w-4" />}
      </AvatarFallback>
    </Avatar>
  </BasicTooltip>
);
